import React from 'react';
import '../styles/LanguageToggle.css';

const LanguageToggle = ({ lang, onToggle }) => (
  <div className="lang-toggle">
    <button
      className={lang === 'ID' ? 'active' : ''}
      onClick={() => onToggle('ID')}
    >ID</button>
    <button
      className={lang === 'EN' ? 'active' : ''}
      onClick={() => onToggle('EN')}
    >EN</button>
  </div>
);

export default LanguageToggle;
